<template>
  <div>
    <ul class="study-type clearfix">
      <li :class="{ active: item.id === studyTab.id }"
        v-for="(item, index) in studyTabList"
        :key="index"
        @click="changeTab(item)"
        v-show="item.list.length > 0"
      >
        <div class="study-type-title">{{ item.title }}</div>
      </li>
    </ul>
    <div v-if="liststatus">
      <chapter-practice :subjectList="subjectList"></chapter-practice>
    </div>
  </div>
</template>
<script>
import ChapterPractice from "./ChapterPractice";
export default {
  props: {
    bank: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      liststatus: false,
      studyTab: {},
      studyTabList: [],
      subjectList: []
    };
  },
  mounted() {
    this.studyTabList = this.list
    // this.initQuestion();
    this.initTabData()
  },
  methods: {

    initTabData() {
      if (this.studyTabList.length > 0) {
        this.studyTabList.map(item =>{
          if(this.studyTab.list){
            return false
          }
          if(item.list.length > 0){
            this.studyTab = item
            return false
          }
        })
        // this.studyTab = this.studyTabList[0];
      }
      if (this.studyTab.list.length > 0){
        this.subjectList = this.studyTab.list
        this.liststatus = true
      }
    },
    changeTab(item) {
      this.studyTab = item;
      this.liststatus = false
      if(item.list.length > 0){
        this.$nextTick(function() {
          this.subjectList = item.list
          this.liststatus = true
        });
      }else{
        this.liststatus = false
      }
    },
  },
  components: {
    ChapterPractice
  },
};
</script>
<style lang="less" scoped>
.study-type {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  justify-content: center;
  li {
    text-align: center;
    font-weight: bold;
    color: #666;
    padding: 5px 20px 10px 20px;
    margin-right: 30px;
    cursor: pointer;
    font-size: 18px;
    &::after {
      content: " ";
      display: block;
      margin: 5px auto 0 auto;
      width: 90px;
      height: 5px;
      background: #fff;
    }
    &:hover {
      color: #2595fd;
    }
    &.active {
      color: #2595fd;
      &::after {
        background: linear-gradient(#27a4ff 21.43%, #227efa 95.7%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mall/study/ExerciseStore.vue